import LetterHead from "./LetterHead";
import ContactMailPhone from "./ContactMailPhone";
import BankAccountAndTaxNumbers from "./BankAccountAndTaxNumbers";

const ProfileContactInfo = () => {

  return (
    <>
      <LetterHead />
      <ContactMailPhone />
      <BankAccountAndTaxNumbers />
    </>
  );
};

export default ProfileContactInfo;
